module.exports = __webpack_public_path__ + "media/images/flags/bz-4eb2d29f4fcc586ae3e27a74fb073cdb.svg";